import { SessionBaseComponent } from '../../../../shared/components/session.base.component';
import { Component, Inject, Injector, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/shared/validators/custom-validators';
import { getFacilityByPermission, getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { RfqCreationService } from '../../service/rfq-creation.service';
import { Dropdown } from 'primeng/dropdown';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import * as ValidationUtils from 'src/app/core/utils/validation-functions';
import { CommonService } from '../../service/common.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { LaasOption } from 'src/app/core/models/laas-option';


@Component({
  selector: 'laas-rfq-creation',
  templateUrl: './rfq-creation.component.html',
  styleUrls: ['./rfq-creation.component.scss']
})
export class RfqCreationComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode = PermissionConstants.ViewRFQSetting;
  currentLang: string = this.laasSetting.language;
  createForm: FormGroup;
  bookingForwarderOptions: any[] = [];
  rfqStatusOptions: any[] = [];
  shipTermOptions: LaasOption[] = [];
  rfqCategoryTypeOptions: any[] = [];
  pickupLocationOptions: any[] = [];

  yesNoOption: any[] = [];
  customerOptions: any[] = [];
  countryOptions: any[] = [];
  allCityOptions: any[] = [];
  allAreaOptions: any[] = [];
  fromCityOptions: any[] = [];
  fromAreaOptions: any[] = [];
  toCityOptions: any[] = [];
  toAreaOptions: any[] = [];

  expressFromAreaOptions: any[] = [];
  expressToAreaOptions: any[] = [];

  expressTermOptions: any[] = [];
  shippingTypeOptions: any[] = [];

  feeTypeOptions: any[] = [];
  calculationUnitOptions: any[] = [];
  currencyOptions: any[] = [];

  rfqDetailList: any[] = [];
  detailColumns: any[] = [];
  isConsolidationOptions: any[] = [];

  defaultDate: any;

  createDetailForm: FormGroup;
  submitted: boolean = false;

  disableDropdown1: boolean = false;
  disableDropdown2: boolean = false;

  facilityOptions: any[] = [];

  constructor(
    injector: Injector,
    private rfqCreationService: RfqCreationService,
    private commonService: CommonService,
    private commonDataService: CommonDataService,
    private facilityService: FacilityService,
    private notificationSubScriptionService: NotificationSubScriptionService,
    private dropdownOptionsService: DropdownOptionsService,
    private fb: FormBuilder
  ) {

    super(injector);

    this.createForm = this.fb.group({
      facility: null,
      facilityList: [null, Validators.required],
      forwarder: [null, Validators.required],
      status: 1,
      fromCountry: [null, Validators.required],
      fromCity: null,
      fromArea: null,
      toCountry: [null, Validators.required],
      toCity: null,
      toArea: null,
      rfqCategory: [null, Validators.required],
      awbAddress: null,
      expressTerm: null,
      consigneekey: null,
      consigneeName: null,
      effectStartDate: [null, Validators.required],
      effectEndDate: [null, Validators.required],
      isActivated: [1, Validators.required],
      remark: null,
      createUser: [null, Validators.required],
      createDt: [null, Validators.required],
      updateUser: [null, Validators.required],
      updateDt: [null, Validators.required],
      currency: [null, Validators.required],
      expressFromArea: null,
      expressToArea: null,
      outsourcingCompany: null,
      shippingType:  null,
      isConsolidation:['N', Validators.required ]
    });

    this.createDetailForm = this.fb.group({
      details: this.fb.array([]),
    });



    this.detailColumns = [
      { field: 'feeType', header: 'RFQNew.CostType' },
      { field: 'incoTerm', header: 'RFQNew.TradeTerm' },
      { field: 'shippingSectionDesc', header: 'RFQNew.TransportDescription' },
      { field: 'currency', header: 'RFQNew.AccountingCurrency' },
      { field: 'unitPrice', header: 'RFQNew.UnitPrice' },
      { field: 'calculationUnit', header: 'RFQNew.CalculationUnit' },
      { field: 'intervalUnitStart', header: 'RFQNew.CalculationRangeStart' },
      { field: 'intervalUnitEnd', header: 'RFQNew.CalculationRangeEnd' },
      { field: 'minimalCharge', header: 'RFQNew.MinimumCost' },
      { field: 'remark', header: 'RFQNew.Remarks' },
      { field: 'isTieredGroup', header: 'RFQNew.IsRFQ' },
    ];

  }

  async ngOnInit(): Promise<void> {

    await super.ngOnInit();

    this.defaultDate = new Date();
    this.createForm.controls.createUser.setValue(this.userProfile.userName);
    this.createForm.controls.createDt.setValue(this.defaultDate);
    this.createForm.controls.updateUser.setValue(this.userProfile.userName);
    this.createForm.controls.updateDt.setValue(this.defaultDate);


    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.bookingForwarderOptions = options.filter((x: any) => {
          return (this.userProfile.userType == UserType.SuperAdmin.toString() ||
            this.userProfile.userType == UserType.Shipping.toString() ||
            getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });


    this.dropdownOptionsService.getRFQStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.rfqStatusOptions = options.map(x => ({ label: x.optionDesc, value: Number(x.optionCode) }));
        }
      });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.shipTermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.shipTermOptions.unshift({
          label: 'ALL',
          value: 'ALL'
        });
      }
    });

    this.dropdownOptionsService.getVCountryOptions()
      .subscribe({
        next: (options: any[]) => {
          this.countryOptions = options.map(x => ({ label: x.countryName, value: x.countryCode }));

          this.countryOptions.unshift({
            label: 'ALL',
            value: 'ALL'
          });
        }
      });

    //
    this.dropdownOptionsService.getVCityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.allCityOptions = options.map(x => ({ label: x.name, value: x.seqNo.toString(), expressArea: x.expressArea, country: x.country }));
        }
      });

    //
    this.dropdownOptionsService.getVAreaOptions()
      .subscribe({
        next: (options: any[]) => {
          this.allAreaOptions = options.map(x => ({ label: x.areaName, value: x.areaCode, city: x.city }));
        }
      });


    this.dropdownOptionsService.getRfqCategoryTypeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.rfqCategoryTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.getPickupLocationOptions()
      .subscribe({
        next: (options: any[]) => {
          this.pickupLocationOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.findFacilityOptionsByOptionType("ExpressTerm")
      .subscribe({
        next: (options: any[]) => {
          this.expressTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.findFacilityOptionsByOptionType("ShippingType")
      .subscribe({
        next: (options: any[]) => {
          this.shippingTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.findFeeTypeByFeeTypeCategory("RFQ")
      .subscribe({
        next: (options: any[]) => {
          this.feeTypeOptions = options.map(x => ({ label: x.feeTypeName, value: x.feeTypeCode }));
        }
      });


      this.dropdownOptionsService.findFacilityOptionsByOptionType("CalculationUnit")
      .subscribe({
        next: (options: any[]) => {
          this.calculationUnitOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.yesNoOption = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    this.commonService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.currency_code}-${x.currency_name}`,
            value: x.currency_code,
          };
        });
      }
    });

    this.dropdownOptionsService.getFacilityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.filter(x => {
          return this.userProfile.userType == UserType.SuperAdmin.toString() ||
              getFacilityByPermission(this.userProfile, this.permissionCode).includes(null) ||
              getFacilityByPermission(this.userProfile, this.permissionCode).includes(x.optionCode)
        })
        .map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.isConsolidationOptions = [
      { label: 'N', value: 'N' },
      { label: 'Y', value: 'Y' }
    ];


  }



  getFromCityOptions(): void {

    if (this.createForm.value.fromCountry == 'ALL') {
      this.fromCityOptions = [{ label: 'ALL', value: 'ALL' }];
      this.fromAreaOptions = [{ label: null, value: null }];
      this.expressFromAreaOptions = [{ label: 'ALL', value: 'ALL' }];
      this.createForm.controls.fromCity.setValue("ALL");
      this.createForm.controls.fromArea.setValue(null);
      this.createForm.controls.expressFromArea.setValue("ALL");
      this.disableDropdown1 = true;
    } else {

      this.createForm.value.fromCity = null;
      this.createForm.value.fromArea = null;
      this.fromCityOptions = this.allCityOptions.filter(x => x.country == this.createForm.value.fromCountry);

      this.createForm.value.expressFromArea = null;
      const temp = [...new Set(this.allCityOptions.filter(x => x.country == this.createForm.value.fromCountry).map(item => item.expressArea))];
      this.expressFromAreaOptions = temp.map(item => ({ label: item, value: item }));

      this.disableDropdown1 = false;
    }

  }

  getFromAreaOptions(): void {
    this.createForm.value.fromArea = null;
    this.fromAreaOptions = this.allAreaOptions.filter(x => x.city == this.createForm.value.fromCity);
  }


  getToCityOptions(): void {

    if (this.createForm.value.toCountry == 'ALL') {
      this.toCityOptions = [{ label: 'ALL', value: 'ALL' }];
      this.toAreaOptions = [{ label: null, value: null }];
      this.expressToAreaOptions = [{ label: 'ALL', value: 'ALL' }];
      this.createForm.controls.toCity.setValue("ALL");
      this.createForm.controls.toArea.setValue(null);
      this.createForm.controls.expressToArea.setValue("ALL");
      this.disableDropdown2 = true;
    } else {

      this.createForm.value.toCity = null;
      this.createForm.value.toArea = null;
      this.toCityOptions = this.allCityOptions.filter(x => x.country == this.createForm.value.toCountry);

      this.createForm.value.expressToArea = null;
      const temp = [...new Set(this.allCityOptions.filter(x => x.country == this.createForm.value.toCountry).map(item => item.expressArea))];
      this.expressToAreaOptions = temp.map(item => ({ label: item, value: item }));

      this.disableDropdown2 = false;

    }

  }

  getToAreaOptions(): void {
    this.createForm.value.toArea = null;
    this.toAreaOptions = this.allAreaOptions.filter(x => x.city == this.createForm.value.toCity);
  }


  getCustomerOptionsByKey(event: any, dropdown: Dropdown): void {
    const key: string = event.filter;
    if (key != null && key.length > 1) {
      this.notificationSubScriptionService.getCustomerOptionsByKey(key).subscribe({
        next: (options: any[]) => {
          this.customerOptions = options.map(x => ({ label: x.customerCode + '-' + x.customerName + '-' + x.engName, value: x.customerCode }));
        }
      });
    }
  }

  addDetailStyle() {

    if (this.rfqDetailList.length > 5) {
      return;
    }

    var facility = this.laasSetting.facility;
    var rfqCategory = this.createForm.value.rfqCategory;

    if (isNullOrEmpty(rfqCategory)) {
      return;
    }

    var params = { facility: facility, rfqCategory: rfqCategory };

    this.rfqCreationService.getRFQDefaultSetting(params)
      .subscribe({
        next: result => {

          var tempList = [];

          for (let i = 0; i < result.length; i++) {
            var temp = result[i];

            let detail = {
              feeType: temp.defaultFeeType,
              incoTerm: null,
              shippingSectionDesc: temp.defaultShippingSectionDesc,
              currency: temp.defaultCurrency,
              unitPrice: temp.defaultUnitPrice,
              calculationUnit: temp.defaultCalculationUnit,
              intervalUnitStart: temp.defaultIntervalUnitStart,
              intervalUnitEnd: temp.defaultIntervalUnitEnd,
              minimalCharge: temp.defaultMinimalCharge,
              remark: null,
              isTieredGroup: temp.defaultIsTieredGroup,
              createUser: this.userProfile.userName,
              createDt: this.defaultDate,
              updateUser: this.userProfile.userName,
              updateDt: this.defaultDate,
            };
            tempList[i] = detail;
          }

          this.rfqDetailList = tempList;
          this.populateData();
        },
        error: (err: any) => {
          this.toastErrorMessage(err.error);
        }
      });

  }

  addDetail() {
    this.createDetailForm.markAllAsTouched();
    this.details.push(this.addControls());
  }


  private addControls() {
    return new FormGroup({
      feeType: new FormControl(null, [Validators.required]),
      incoTerm: new FormControl(null, [Validators.required]),
      shippingSectionDesc: new FormControl(null),
      currency: new FormControl(null, [Validators.required]),
      unitPrice: new FormControl(null, [Validators.required]),
      calculationUnit: new FormControl(null, [Validators.required]),
      intervalUnitStart: new FormControl(null, [Validators.required]),
      intervalUnitEnd: new FormControl(null, [Validators.required]),
      minimalCharge: new FormControl(null, [Validators.required]),
      isTieredGroup: new FormControl(null, [Validators.required]),
      remark: new FormControl(null),
      createUser: new FormControl(this.userProfile.userName),
      createDt: new FormControl(this.defaultDate),
      updateUser: new FormControl(this.userProfile.userName),
      updateDt: new FormControl(this.defaultDate),
    });
  }

  get details(): FormArray {
    return this.createDetailForm.get("details") as FormArray;
  }

  private populateData() {
    this.rfqDetailList.forEach((data, index) => {
      this.addDetail();
      this.details.controls[index].setValue(data);
    });
  }

  deleteBtnClick(event: any, detailList: any, idx: number): void {
    this.details.removeAt(idx);
  }


  //
  createClick() {

    let facilityList = this.createForm.value.facilityList;
    if(facilityList == null || facilityList.length == 0){
      this.createForm.controls.facility.setValue(this.laasSetting.facility);
    }else{
      let str = facilityList.toString();
      this.createForm.controls.facility.setValue(str);
    }

    if (isNullOrEmpty(this.createForm.controls.consigneekey)) {
      this.createForm.controls.consigneeName.setValue(null);
    }

    if (this.createForm.invalid) {
      this.submitted = true;
      this.translateService.get('RFQSetting.Alert.CheckMainPage')
        .subscribe({
          next: msg => {
            this.toastService.warn(msg);          }
        });
      this.loader.hide();
      return;
    }

    if (this.createDetailForm.value.details.length === 0) {
      this.submitted = true;
      this.toastService.warn('請檢查明細是否填寫');
      this.loader.hide();
      return;
    }

    if (this.createDetailForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('RFQSetting.Alert.CheckDetailedList'));
      this.loader.hide();
      return;
    }

    var effectStartDate = this.createForm.value.effectStartDate;
    var effectEndDate = this.createForm.value.effectEndDate;

    if (effectStartDate > effectEndDate) {
      this.toastService.warn(this.translateService.instant('RFQSetting.Alert.EffectiveGreater'));
      this.loader.hide();
      return;
    }

    var rfqEntity = this.createForm.value;
    var rfqDetailEntity = this.createDetailForm.value;

    let obj = { rfqEntity: rfqEntity, rfqDetailEntity: rfqDetailEntity.details };
    console.log(obj);

    this.confirmationService.confirm({
      message: this.translateService.instant('RFQSetting.Confirm.ConfirmRFQ'),
      header: '新增',
      rejectVisible: true,
      accept: () => {

        this.rfqCreationService.addRfq(obj)
          .subscribe({
            next: result => {

              this.toastService.info(this.translateService.instant('RFQSetting.Info.AddSuccess'));
              this.routeStateService.navigateTo('/Setting/RfqSetting');
              this.loader.hide();

            },
            error: (err: any) => {
              this.toastErrorMessage(err.error);
            }
          });

      },
      reject: () => {
        this.confirmationService.close();
      }
    });

  }


  showValidationMessage(control: AbstractControl | null, submitted: boolean): boolean {
    return ValidationUtils.showValidationMessage(control, submitted);
  }

  changeConsignee(event: any) {
    if (!event) {
      this.createForm.controls.consigneeName.setValue(null);
      return;
    }
      const selectedOption = this.customerOptions.find(opt => opt.value === event);
      if (selectedOption && selectedOption.label) {
      let label = selectedOption.label;
      const name = label.substring(label.indexOf('-') + 1).trim();
      this.createForm.controls.consigneeName.setValue(name);
    }
  }


  getExpressInfo() {

    this.facilityService.getFacilityForwarderExpressInfo(this.laasSetting.facility, this.createForm.value.forwarder)
      .subscribe({
        next: (result: any) => {

          var isExpressBill = result.isExpressBill;

          // 改變必填欄位
          if (isExpressBill == 1) {

            this.createForm.controls.fromCity.clearValidators();
            this.createForm.controls.fromCity.updateValueAndValidity();

            this.createForm.controls.toCity.clearValidators();
            this.createForm.controls.toCity.updateValueAndValidity();

            this.createForm.controls.expressFromArea.setValidators(Validators.required);
            this.createForm.controls.expressFromArea.updateValueAndValidity();

            this.createForm.controls.expressToArea.setValidators(Validators.required);
            this.createForm.controls.expressToArea.updateValueAndValidity();

          } else {

            this.createForm.controls.fromCity.setValidators(Validators.required);
            this.createForm.controls.fromCity.updateValueAndValidity();

            this.createForm.controls.toCity.setValidators(Validators.required);
            this.createForm.controls.toCity.updateValueAndValidity();

            this.createForm.controls.expressFromArea.clearValidators();
            this.createForm.controls.expressFromArea.updateValueAndValidity();

            this.createForm.controls.expressToArea.clearValidators();
            this.createForm.controls.expressToArea.updateValueAndValidity();

          }

        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
      });

  }

  onCustomerListLoaded(list: any[]) {
  this.customerOptions = list;
  const currentKey = this.createForm.controls.consigneekey.value;
  if (currentKey) {
    this.changeConsignee(currentKey);
  }
}



}
